import styled from "styled-components";

export const WordcloudPlaceholder = styled.div`
  height: 300px;
  margin: 64px 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
